import { SVGProps } from 'react'

type FileIconProps = SVGProps<SVGSVGElement>

const FileIcon = ({ className, ...props }: FileIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={21}
    fill="none"
    className={className}
    {...props}
  >
    <path
      fill="#fff"
      d="M13.564 0H6.047l-.383.382L.382 5.664 0 6.046v11.43A3.527 3.527 0 0 0 3.523 21h10.041a3.527 3.527 0 0 0 3.523-3.523V3.523A3.527 3.527 0 0 0 13.564 0Zm2.219 17.477a2.218 2.218 0 0 1-2.219 2.218H3.524a2.218 2.218 0 0 1-2.22-2.218V6.587h3.434c1.02 0 1.849-.828 1.849-1.849V1.304h6.977c1.225 0 2.219.994 2.219 2.219v13.954Z"
    />
    <path
      fill="#fff"
      d="M13.088 3.821H9.424v3.666h3.665V3.821ZM13.088 9.54h-9.09v1.026h9.09V9.54ZM13.088 12.472h-9.09V13.5h9.09v-1.027ZM13.088 15.405h-9.09v1.026h9.09v-1.026Z"
    />
  </svg>
)
export default FileIcon
